import React from 'react';
import dayjs from 'dayjs';

export type InvoicePaymentAuditFields = {
  officeMarkedPaidOn?: string | null; talentMarkedPaidOn?: string | null;
  paidMethod?: string | null; paidNote?: string | null; officeMarkedPaid?: boolean;
  dentistMarkedPaid?: number | boolean | null; hygienistMarkedPaid?: number | boolean | null;
};

export function officeInvoiceIsPaid(invoice: { dentistMarkedPaid?: unknown; hygienistMarkedPaid?: unknown; officePaymentStatus?: unknown } | null | undefined) {
  return Number(invoice?.dentistMarkedPaid) > 0 || Number(invoice?.hygienistMarkedPaid) > 0 || invoice?.officePaymentStatus === 'paid';
}

export default function InvoicePaymentAudit({ invoice, audience, officeName = 'the office', talentName = 'the Talent' }: {
  invoice?: InvoicePaymentAuditFields | null; audience: 'office' | 'talent'; officeName?: string; talentName?: string;
}) {
  if (!invoice) return null;
  const date = (value?: string | null) => value && dayjs(value).isValid() ? ` on ${dayjs(value).format('MMM D, YYYY')}` : '';
  const officeMarked = invoice.officeMarkedPaid || Number(invoice.dentistMarkedPaid) === 2;
  const talentMarked = Number(invoice.hygienistMarkedPaid) > 0;
  if (!officeMarked && !talentMarked) return null;
  return <div data-testid="invoice-payment-audit" style={{ overflowWrap: 'anywhere', margin: '12px 0', fontSize: 14 }}>
    {officeMarked && <p data-testid="invoice-office-paid-audit">
      Marked paid by {audience === 'office' ? 'you' : officeName}{invoice.paidMethod ? ` via ${invoice.paidMethod}` : ''}{date(invoice.officeMarkedPaidOn)}
      {!invoice.paidMethod && !invoice.officeMarkedPaidOn ? '. Method and date were not recorded.' : ''}
    </p>}
    {officeMarked && invoice.paidNote && <p data-testid="invoice-office-paid-note">{invoice.paidNote}</p>}
    {talentMarked && <p data-testid="invoice-talent-paid-audit">
      Marked paid by {audience === 'talent' ? 'you' : talentName}{date(invoice.talentMarkedPaidOn)}
    </p>}
  </div>;
}
